import api from './axios';
import { Customer, CustomerContact } from '../types';

export const getCustomers = () => api.get<Customer[]>('/customers').then(r => r.data);
export const getCustomer = (id: number) => api.get<Customer>(`/customers/${id}`).then(r => r.data);
export const createCustomer = (data: Partial<Customer>) => api.post<Customer>('/customers', data).then(r => r.data);
export const updateCustomer = (id: number, data: Partial<Customer>) => api.put<Customer>(`/customers/${id}`, data).then(r => r.data);
export const deleteCustomer = (id: number) => api.delete(`/customers/${id}`);
export const searchCustomers = (q: string) => api.get<Customer[]>(`/customers/search?q=${q}`).then(r => r.data);

// Contacts
export const getContacts = (customerId: number) => api.get<CustomerContact[]>(`/customers/${customerId}/contacts`).then(r => r.data);
export const addContact = (customerId: number, data: Partial<CustomerContact>) => api.post<CustomerContact>(`/customers/${customerId}/contacts`, data).then(r => r.data);
export const updateContact = (contactId: number, data: Partial<CustomerContact>) => api.put<CustomerContact>(`/customers/contacts/${contactId}`, data).then(r => r.data);
export const deleteContact = (contactId: number) => api.delete(`/customers/contacts/${contactId}`);
export const migrateContacts = () => api.post('/customers/migrate-contacts').then(r => r.data);
